/** Page opened after a sign-in when none was asked for. */
export const DEFAULT_REDIRECT = "/catalogue";

/**
 * `value` if it is a path of this app, else the catalogue: a protocol-relative URL (`//evil.example`,
 * `/\evil.example`) or an absolute one would leave the app after the sign-in (open redirect).
 * Mirrors `safe_next` (core/src/core/services/auth.py).
 */
export function safeRedirect(value: unknown): string {
	if (
		typeof value !== "string" ||
		value.length > 512 ||
		!value.startsWith("/") ||
		value.startsWith("//") ||
		value.includes("\\") ||
		// biome-ignore lint/suspicious/noControlCharactersInRegex: rejecting them is the point
		/[\u0000-\u001f\u007f]/.test(value)
	)
		return DEFAULT_REDIRECT;
	return value;
}
